export default "__VITE_ASSET__lWh_n6EA__"